class pdpFeaturesIcons extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      shareBtn: '[href="#share-button"]',
      compareBtn: '[href="#compare-button"]',
      wishlistBtn: '[href="#wishlist-button"]',
      shareWrapper: '.social-share__wrapper',
    };

    this.init();
    this.bindEvents();
  }

  init() {
    this.shareBtn = this.querySelector(this.selectors.shareBtn);
    this.compareBtn = this.querySelector(this.selectors.compareBtn);
    this.wishlistBtn = this.querySelector(this.selectors.wishlistBtn);
    this.shareWrapper = this.querySelector(this.selectors.shareWrapper);
  }

  bindEvents() {
    if (this.shareBtn) {
      this.shareBtn.addEventListener('click', (event) => {
        event.preventDefault();
        if (this.shareWrapper && this.shareWrapper.classList.contains('active')) {
          this.shareWrapper.style.setProperty('--height', `0px`);
          this.shareWrapper.classList.remove('active');
          this.shareBtn.classList.remove('active');
        } else {
          this.shareWrapper.style.setProperty('--height', `${this.shareWrapper.scrollHeight + 30}px`);
          this.shareWrapper.classList.add('active');
          this.shareBtn.classList.add('active');
        }
      });
    }

    if (this.compareBtn) {
      this.compareBtn.addEventListener('click', (event) => {
        event.preventDefault();
        const button = this.parentElement.querySelector('.product-form__buttons .sp-button.sp-button-compare');
        if (button) button.click();
      });
    }

    if (this.wishlistBtn) {
      this.wishlistBtn.addEventListener('click', (event) => {
        event.preventDefault();
        const button = this.wishlistBtn.querySelector('button');
        if (button) button.click();
      });
    }
  }
}

customElements.define('pdp-featues-icon', pdpFeaturesIcons);